import Vue from 'vue'
import Vuex from 'vuex'
import exam from "./module/exam"
import autoInput from "./module/auto-input"
Vue.use(Vuex)

const store = new Vuex.Store({
    state:{
        userInfo: null,
        source: "",
        company: {},
        companyList: [],
        ua: null
    },
    mutations: {
        updateUser(state, userInfo){
            state.userInfo = userInfo
        },
        updateSource(state, source){
            state.source = source
        },
        updateCompany(state, company){
            state.company = company
        },
        updateCompanyList(state, companyList){
            state.companyList = companyList
        },
        updateUa(state, ua){
            state.ua = ua
        }
    },
    actions:{
        
    },
    modules:{
        exam,
        autoInput
    }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js